import React from "react";
import dynamic from "next/dynamic";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import BigHeroSection from "./partials/BigHeroSection";

import type { ILandingPageProps } from "../../interface";

const ContainerBottomLandingPage = dynamic(() => import("./DesktopBottomSection"), { ssr: false });
const Footer = dynamic(() => import("@layouts/Footer"), { ssr: false });
const ButtonHelp = dynamic(() => import("@atoms/ButtonHelp"), { ssr: false });
const FABScrollDown = dynamic(() => import("@fragments/FABScrollDown"), { ssr: false });

import useStyles from "./styles";

const Desktop: React.FC<ILandingPageProps> = ({
  popularProduct,
  banner,
  testimony,
  backgroundLead,
  dataNavbar,
}) => {
  const classes = useStyles({ isVisible: true });
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const onClickToForm = () => {
    return document.querySelector("#product-customer")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      <Box component="main" className={classes.base}>
        <FABScrollDown id="fab-scroll-down" onClick={onClickToForm} />
        <BigHeroSection banner={banner} isDesktop={isDesktop} />

        <ContainerBottomLandingPage
          popularProduct={popularProduct}
          testimony={testimony}
          backgroundLead={backgroundLead}
          isDesktop={isDesktop}
        />
      </Box>
      <Footer bgColor="grey-mid" dataNavbar={dataNavbar} />
      <ButtonHelp />
    </>
  );
};

export default Desktop;
